import styled from "styled-components";

export const SignUpModalStyles = styled.div`
  background-color: rgba(0, 0, 0, 0.25);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0%;
  right: 0%;
  z-index: 1000;
  .messageBox {
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    background-color: var(--bg-white);
    max-width: 1264px;
    min-height: max-content;
    position: absolute;
    overflow-y: auto;
    min-height: 742px;
    left: 17.08%;
    right: 17.08%;
    top: 15.65%;
    bottom: 15.65%;
    max-height: 742px;
    padding: 40px 60px 60px 60px;
    border-radius: 10px;
    margin: auto;
    border: 1px solid #e7e8f3;
    @media (max-width: 1024px) {
      padding: 20px 20px;
    }
    @media (max-width: 990px) {
      left: 8%;
      right: 8%;
      top: 5%;
      bottom: 5%;
      min-height: 630px;
      padding-bottom: 0;
    }
    @media (max-width: 768px) {
      left: 2%;
      right: 2%;
      top: 2%;
      bottom: 2%;
      padding: 10px 10px;
      padding-bottom: 0;
    }
    /* filter: drop-shadow(0px 0px 20px rgba(6, 40, 112, 0.2)); */
    .up {
      color: black;
      color: var(--primary-600);
      font-size: 18px;
      font-weight: 700;
      text-align: right;
      display: flex;
      align-items: center;
      direction: rtl;
      justify-content: space-between;
      padding-bottom: 16px;
      border-bottom: 1px solid #e7e8f3;
      & svg {
        cursor: pointer;
      }
      @media (max-width: 990px) {
        padding-bottom: 8px;
      }
    }
    .main {
      direction: rtl;
      display: flex;
      width: 100%;
      & .content {
        overflow-y: auto;
        max-height: 521px;
        padding: 0px 40px 32px 40px;
        margin-top: 32px;
        flex: 2;
        font-size: 14px;
        font-weight: 400;
        line-height: 30px;
        color: var(--text-500);
        @media (max-width: 990px) {
          padding: 0 10px 10px 10px;
          font-size: 12px;
          line-height: 20px;
          margin-top: 10px;
        }
      }
      & .sidebar {
        padding-top: 45px;
        flex: 1;

        & .sidebarItem {
          margin-bottom: 31px;
          & a {
            color: var(--text-300);
            font-size: 14px;
            font-weight: 500;
            @media (max-width: 1024px) {
              font-size: 12px;
            }
            &:hover {
              color: var(--primary-500);
            }
          }
          @media (max-width: 1024px) {
            margin-bottom: 14px;
          }
        }
        & .active {
          margin-bottom: 31px;
          a {
            color: var(--primary-500);
            font-size: 14px;
            font-weight: 500;
          }
        }
      }
    }
    /* p {
      direction: rtl;
      padding: 1rem;
      padding-top: 0%;
      font-family: "Iran-Yekan";
      font-size: 1.1rem;
      text-align: center;
    } */
    .btns {
      display: flex;
      align-items: center;
      justify-content: space-between;
      direction: rtl;
      & ul {
        display: flex;
        & li {
          font-size: 12px;
          color: var(--text-500);
          font-weight: 400;
          @media (max-width: 990px) {
            margin-left: 0px;
            font-size: 10px;
          }
        }
        & li:first-child {
          margin-left: 19px;
          @media (max-width: 990px) {
            margin-left: 5px;
            font-size: 10px;
          }
        }
        & li:last-child {
          margin-right: 5px;
        }
      }
      & button {
        background-color: var(--primary-400);
        color: var(--bg-white);
        font-size: 14px;
        font-weight: 500;
        margin-top: 40px;
        margin-left: 40px;
        @media (max-width: 990px) {
          margin-left: 20px;
          margin-top: 20px;
        }
      }
    }
  }
  .checkbox {
    direction: rtl;
    display: flex;
    align-items: center;
    font-family: "Iran-Yekan";
    padding-bottom: 0.8rem;
    input {
      margin-left: 0.5rem;
      scale: 1.2;
    }
  }
`;
